import '../link-to-element';
import '../picture';

export default (ctx, html) => html`
<footer>
  <aofl-img id="aofl-svg" src="/assets/templates/main-footer/aofl-logo-v1.svg" height="45.9" width="373" alt=""></aofl-img>
  <slot></slot>
</footer>
`;
